import React from 'react';

import Select from 'components/Select';
import { I18n } from 'react-redux-i18n';
import { Option } from 'interface';

const PricesCompareSelectCompetitor = ({
  network,
  competitor,
  setCompetitor,
  setActiveRadioButton,
  competitors
}: {
  network: string | null;
  competitor: string | null;
  competitors: string[];
  // eslint-disable-next-line no-unused-vars
  setCompetitor: (e: string | null) => void;
  // eslint-disable-next-line no-unused-vars
  setActiveRadioButton: (e: any) => void;
}) => {
  const onChange = (selectedOption: string | null) => {
    setCompetitor(selectedOption);
    setActiveRadioButton('Comparer avec un concurrent');
  };

  return (
    <div className="selectSetsContainer ignored-export">
      {network !== 'WEB' && (
        <Select
          value={competitor ? { label: competitor, value: competitor } : null}
          className="bigSelect"
          isClearable
          options={competitors.map((item) => ({ label: item, value: item }))}
          onChange={(value: Option) => onChange(value ? value.value : null)}
          placeholder={I18n.t('prices.placeholderRival')}
          customStyles={{
            control: {
              height: '40px',
              minHeight: '40px',
              width: '350px',
              padding: 0
            },
            container: {
              width: 350,
              height: 40,
              padding: 0
            },
            valueContainer: {
              height: '40px !important',
              padding: 0
            }
          }}
          dropdownProps={{
            styles: competitor ? `margin-left:0px` : `margin-left:-25px`
          }}
          clearProps={{
            styles: `margin-left:-50px`
          }}
        />
      )}
    </div>
  );
};

export default PricesCompareSelectCompetitor;
